module.exports = __webpack_public_path__ + "static/media/landing_page_bg.bf655476.svg";


//////////////////
// WEBPACK FOOTER
// ./src/components/pages/LandingPage/landing_page_bg.svg
// module id = 577
// module chunks = 0